import { render, staticRenderFns } from "./Thumbs.vue?vue&type=template&id=e12d79e6&scoped=true&"
import script from "./Thumbs.vue?vue&type=script&lang=js&"
export * from "./Thumbs.vue?vue&type=script&lang=js&"
import style0 from "./Thumbs.vue?vue&type=style&index=0&id=e12d79e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12d79e6",
  null
  
)

export default component.exports